export enum ThisPaths {
    MENU = "/menu",
    HISTORY = "/history",
    LOGIN = "/login",
    ACTIVATE_ACCOUNT = "/activate-account",
    CHANGE_PASSWORD = "/change-password",
    FORGOT_PASSWORD = "/forgot-password",
}

export enum CommonConfig {
    PAGINATION_LIMIT = 5,
    ITEMS_PER_PAGE = 10,
}

export enum OperationType {
    ADD = "ADD",
    SUBTRACT = "SUBTRACT",
}

export enum BalanceEventType {
    ORDER = "ORDER",
}

export enum ApplicationType {
    TOTEM = "TOTEM",
    PWA = "PWA",
}

export enum GenericErrors {
    WRONG = "Algo salio mal, comuniquese con mesa de ayuda.",
}
